import { usePage } from '@inertiajs/react';
import type { PageProps } from '@/types/global';

export function useTypedPageProps<
    // T is a generic type parameter that defaults to an empty record or array
    T extends Record<never, never> | unknown[] =
        | Record<never, never>
        | unknown[],
>(): ReturnType<typeof usePage<PageProps<T>>> {
    // Returns usePage with our PageProps type (shared data) combined with any page-specific props (T)
    return usePage<PageProps<T>>();
}
